import errorMessages from '../locales/en/errormessage.json';

/**
 * Resolves a dot-separated error message code (e.g. "errormessage.kontent.someitemspublished")
 * against the errormessage.json tree and substitutes {{param1}}, {{param2}}, ... placeholders
 * with the provided params map.
 */
export function formatErrorMessageWithParams(
  code: string,
  params?: Record<string, string>,
): string {
  const parts = code.split('.');
  const path = parts.slice(1);

  let current: unknown = errorMessages;
  for (const key of path) {
    if (current && typeof current === 'object' && key in (current as Record<string, unknown>)) {
      current = (current as Record<string, unknown>)[key];
    } else {
      return code;
    }
  }

  if (typeof current !== 'string') {
    return code;
  }

  if (!params) {
    return current;
  }

  if (current.includes('{{allParams}}')) {
    const joined = Object.keys(params)
      .sort()
      .map((k) => params[k])
      .join('\n\n');
    return current.replace(/\{\{allParams\}\}/g, joined);
  }

  return Object.entries(params).reduce(
    (msg, [key, value]) => msg.replace(new RegExp(`\\{\\{${key}\\}\\}`, 'g'), value),
    current,
  );
}
